import React from "react";
import "./SectionHeader.css";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  centered?: boolean;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  description,
  centered = true,
  className = "",
}) => {
  const baseClasses = "section-header";
  const centeredClasses = centered ? "section-header--centered" : "";

  const combinedClasses = [baseClasses, centeredClasses, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={combinedClasses}>
      {subtitle && <span className="section-header__subtitle">{subtitle}</span>}

      <h2 className="section-header__title">{title}</h2>

      {description && (
        <p className="section-header__description">{description}</p>
      )}

      <div className="section-header__divider">
        <div className="section-header__divider-line"></div>
        <div className="section-header__divider-dot"></div>
        <div className="section-header__divider-line"></div>
      </div>
    </div>
  );
};

export default SectionHeader;
